import styled from 'styled-components';

import { COLORS, TYPOGRAPHY } from '../styles';

const NavItem = styled.div`
  font-style: normal;
  font-family: ${TYPOGRAPHY.fontFamily};
  font-weight: normal;
  font-size: 18px;
  margin: 0;
  padding: 0 21px 0 21px;
  height: 64px;
  line-height: 100%;

  display: flex;
  align-items: center;
  text-align: center;
  position: relative;

  color: ${COLORS.neutral_600};
  text-decoration: none;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: transparent;
  }

  &.active:not(.disabled) {
    background-color: ${COLORS.neutral_20};
    color: ${COLORS.neutral_800};
    &:after {
      background-color: ${COLORS.primary_600};
    }
  }

  &.disabled {
    color: ${COLORS.neutral_300};
    background-color: ${COLORS.neutral_100};
    &:after {
      background-color: ${COLORS.neutral_100};
    }
  }

  &:hover:not(.disabled) {
    background-color: ${COLORS.primary_20};
    color: ${COLORS.primary_700};
    &:after {
      background-color: ${COLORS.primary_600};
    }
  }

  &:focus:not(.disabled) {
    box-shadow: 0px 0px 8px ${COLORS.primary_500}, 0px 4px 12px rgba(46, 127, 161, 0.25);
    outline: none;
    &:after {
      background-color: ${COLORS.primary_600};
    }
  }
`;

export default NavItem;
